module.exports = __webpack_public_path__ + "img/sld_scb_5_t1_green.28e6c4d6.svg";